// libraries
import { useContext } from 'react'

// components
import { FormContext } from '/react4xp/components/Form/Form'

interface UseFormFieldProps {
	name?: string
	externalError?: string
	externalInvalid?: boolean
	required?: boolean
}

export const useFormField = ({
	name,
	externalError,
	externalInvalid,
	required
}: UseFormFieldProps) => {
	
	// check if form context is available
	const formContext = useContext(FormContext)
	
	// get validation state from react hook form
	const formError = name && formContext ? formContext.form.formState.errors[name]?.message as string : null
	const formInvalid = name && formContext ? !!formContext.form.formState.errors[name] : false

	// use external props if provided, otherwise use form validation state
	const finalError = externalError || formError
	const finalInvalid = externalInvalid !== undefined ? externalInvalid : formInvalid

	// helper function to update form value and trigger validation
	const updateFormValue = (value: string) => {
		if (name && formContext) {
			formContext.form.setValue(name, value, { shouldValidate: true })
		}
	}

	// helper function to get register props
	const getRegisterProps = (validationRules?: Record<string, unknown>) => {
		if (!formContext || !name) return {}
		
		return formContext.form.register(name, {
			required: required && 'This field is required',
			...validationRules
		})
	}

	return {
		formContext,
		finalError,
		finalInvalid,
		updateFormValue,
		getRegisterProps
	}
} 